export default "__VITE_ASSET__D3tS3bUm__"